import { render, staticRenderFns } from "./MergeSchoolsModal.vue?vue&type=template&id=44e4b0b6&scoped=true"
import script from "./MergeSchoolsModal.vue?vue&type=script&lang=js"
export * from "./MergeSchoolsModal.vue?vue&type=script&lang=js"
import style0 from "./MergeSchoolsModal.vue?vue&type=style&index=0&id=44e4b0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e4b0b6",
  null
  
)

export default component.exports